import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from '../store';
import { selectHasUnsavedChanges } from '../store/selectors/createCRSelectors';

export const useNavigationGuard = () => {
  const location = useLocation();
  const hasUnsavedChanges = useAppSelector(selectHasUnsavedChanges);
  const isOnCreatePage = location.pathname === '/create';

  const confirmNavigation = useCallback((targetPath: string): boolean => {
    // Only show confirmation if we're on the create page and have unsaved changes
    if (!isOnCreatePage || !hasUnsavedChanges) {
      return true;
    }

    // Don't show confirmation if navigating within the same page
    if (targetPath === location.pathname) {
      return true;
    }

    // Show confirmation dialog
    const confirmed = window.confirm(
      'You have unsaved changes that will be lost. Are you sure you want to leave this page?'
    );

    return confirmed;
  }, [isOnCreatePage, hasUnsavedChanges, location.pathname]);

  return {
    hasUnsavedChanges: isOnCreatePage && hasUnsavedChanges,
    confirmNavigation
  };
};